module.exports = __webpack_public_path__ + "img/IMG_1454_L_Black.fc012812.jpg";